import type { Holding } from '@/hooks/usePortfolio';
import { CompanyFeed } from '@/components/CompanyFeed';
import type { WatchlistItem } from '@/hooks/useWatchlist';

import { FullAnalysisLink } from '../FullAnalysisLink';

interface Props {
  company: WatchlistItem['company'] | Holding['company'];
}

export const Updates = ({ company }: Props) => (
  <>
    <CompanyFeed lookup={company.canonicalURL} />
    <FullAnalysisLink company={company} />
  </>
);
